"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const LocalElements = __importStar(require("../elements"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const productQuery = (0, graphql_tag_1.default) `
  query ProductVariantPrice($input: ComponentCostPriceInformationInputType!) {
    product {
      componentCostPriceInformation(input: $input) {
        type
        breakDownTable {
          name
          value
          description
          partId
        }

        factorsTable {
          description
          factor
          value
        }
      }
    }
  }
`;
function Component(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: productQuery, variables: {
            input: {
                productId: props.productId,
                properties: property_1.PropertyValueSet.toString(props.properties),
                currency: props.currencyCode,
                salesOrganisationId: props.salesOrgCode
            }
        } }, product => {
        const priceInfo = product.product.componentCostPriceInformation;
        if (!priceInfo) {
            return (React.createElement(LocalElements.ResultPresenterContainer, null,
                React.createElement(LocalElements.ErrorSpan, null, "No price information found")));
        }
        const newPriceInfo = parsePrice(priceInfo);
        return (React.createElement(LocalElements.ResultPresenterContainer, null,
            React.createElement(LocalElements.TableSection, null, newPriceInfo.map(priceInfo => {
                return (React.createElement("div", { key: priceInfo.type },
                    React.createElement(Elements.H3, null, priceInfo.type),
                    React.createElement(Elements.FlexContainerRow, { center: false }, priceInfo.breakDownTable && (React.createElement(Elements.DataPresenterTable, null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, priceInfo.breakDownTable.nameHeading),
                                React.createElement("th", null, priceInfo.breakDownTable.valueHeading),
                                React.createElement("th", null, priceInfo.breakDownTable.descriptionHeading),
                                React.createElement("th", null, priceInfo.breakDownTable.partIdHeading))),
                        React.createElement("tbody", null, priceInfo.breakDownTable.rows.map(cp => (React.createElement("tr", { key: cp.name },
                            React.createElement("td", null, cp.name),
                            React.createElement("td", null, cp.value),
                            React.createElement("td", null, cp.description),
                            React.createElement("td", null, cp.partId)))))))),
                    priceInfo.factorsTable && (React.createElement(Elements.DataPresenterTable, null,
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, priceInfo.factorsTable.descriptionHeading),
                                React.createElement("th", null, priceInfo.factorsTable.factorHeading),
                                React.createElement("th", null, priceInfo.factorsTable.valueHeading))),
                        React.createElement("tbody", null, priceInfo.factorsTable.rows.map(cp => (React.createElement("tr", { key: cp.description },
                            React.createElement("td", null, cp.description),
                            React.createElement("td", null, cp.factor),
                            React.createElement("td", null,
                                cp.value,
                                " ",
                                props.currencyCode,
                                " "))))))),
                    React.createElement("span", null,
                        React.createElement("hr", { style: {
                                borderTop: "dotted 1px black"
                            } }))));
            }))));
    }));
}
function parsePrice(componentCostInfo) {
    return componentCostInfo.map(priceInfo => {
        return {
            type: priceInfo.type,
            // biome-ignore lint: -
            breakDownTable: !!priceInfo.breakDownTable.length
                ? {
                    nameHeading: priceInfo.breakDownTable[0].name,
                    valueHeading: priceInfo.breakDownTable[0].value,
                    descriptionHeading: priceInfo.breakDownTable[0].description,
                    partIdHeading: priceInfo.breakDownTable[0].partId,
                    rows: priceInfo.breakDownTable.slice(1).map(x => ({
                        description: x.description,
                        name: x.name,
                        value: x.value,
                        partId: x.partId
                    }))
                }
                : undefined,
            // biome-ignore lint: -
            factorsTable: !!priceInfo.factorsTable.length
                ? {
                    descriptionHeading: priceInfo.factorsTable[0].description,
                    factorHeading: priceInfo.factorsTable[0].factor,
                    valueHeading: priceInfo.factorsTable[0].value,
                    rows: priceInfo.factorsTable.slice(1).map(x => ({
                        description: x.description,
                        factor: x.factor,
                        value: x.value
                    }))
                }
                : undefined
        };
    });
}
//# sourceMappingURL=result-presenter.js.map